import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import ButyArticle from "../pages/article/buty/page";
import BezpieczenstwoArticle from "../pages/article/bezpieczenstwo/page";
import WysylkaArticle from "../pages/article/wysylka/page";
import PoczatkujacyArticle from "../pages/article/poczatkujacy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artykul/kakobuy-spreadsheet-poradnik",
    element: <ArticlePage />,
  },
  {
    path: "/artykul/kakobuy-buty-poradnik",
    element: <ButyArticle />,
  },
  {
    path: "/artykul/kakobuy-bezpieczenstwo",
    element: <BezpieczenstwoArticle />,
  },
  {
    path: "/artykul/kakobuy-wysylka-polska",
    element: <WysylkaArticle />,
  },
  {
    path: "/artykul/kakobuy-dla-poczatkujacych",
    element: <PoczatkujacyArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;